"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileDropzone = void 0;
var FileDropzone_1 = require("./FileDropzone");
Object.defineProperty(exports, "FileDropzone", { enumerable: true, get: function () { return FileDropzone_1.FileDropzone; } });
